import React from 'react';
import { SvgIcon } from '@mui/material';
import type { SvgIconProps } from '@mui/material';

// Round chat-bubble icon from Figma (node 20997-33561, icon-chat). viewBox 0 0 64 64.
// Filled with the brand linear gradient (#0C71E7 -> #00CE81, left-to-right).
const EmptyChatIcon: React.FC<SvgIconProps> = (props) => (
  <SvgIcon viewBox="0 0 64 64" {...props}>
    <defs>
      <linearGradient
        id="emptyChatIconGradient"
        x1="2.66669"
        y1="31.9994"
        x2="61.3334"
        y2="31.9994"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#0C71E7" />
        <stop offset="1" stopColor="#00CE81" />
      </linearGradient>
    </defs>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      fill="url(#emptyChatIconGradient)"
      d="M32 2.66602C48.2004 2.66602 61.3334 15.799 61.3334 31.9993C61.3334 48.1997 48.2004 61.3327 32 61.3327C27.5445 61.3327 23.3211 60.3393 19.539 58.562L17.7858 59.1422C11.821 61.0539 7.6532 61.7144 5.28224 61.1233C2.48308 60.4256 1.93066 59.2044 3.62499 57.4599C4.79619 56.0644 5.77219 54.3199 6.55299 52.2265C7.17526 50.5582 6.92966 48.225 5.81618 45.2271C3.79966 41.2513 2.66669 36.7577 2.66669 31.9993C2.66669 15.799 15.7997 2.66602 32 2.66602ZM32 7.99935C18.7452 7.99935 8.00002 18.7445 8.00002 31.9993C8.00002 35.4994 8.74656 38.8803 10.1683 41.9771L10.5727 42.8146L10.7101 43.0855L10.8158 43.3702C12.333 47.4552 12.7054 50.9928 11.55 54.0904L11.1677 55.0621L10.976 55.4953L11.2107 55.4448C12.5902 55.1286 14.2283 54.6779 16.0971 54.082L17.8182 53.5139L19.8574 52.8188L21.8073 53.7351C24.9663 55.2196 28.4226 55.9993 32 55.9993C45.2549 55.9993 56 45.2542 56 31.9993C56 18.7445 45.2549 7.99935 32 7.99935Z"
    />
  </SvgIcon>
);

export default EmptyChatIcon;
